<div class="m-2 mr-3">
  <div class="flex flex-row justify-between">
    <div class="flex flex-row">
      <div class="mx-1">
        <mat-form-field>
          <mat-label>Region</mat-label>
          <mat-select [formControl]="regionControl">
            <mat-option *ngFor="let region of regions$ | async; trackBy: 'id' | trackByKey" [value]="region.ID">
              {{ region.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="mx-1">
        <mat-form-field>
          <mat-label>Date</mat-label>
          <input matInput autocomplete="off" [min]="date" [formControl]="startControl" [matDatepicker]="picker" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <!--<div class="flex flex-row items-center text-gray-600 text-sm">
      <div class="flex flex-row items-center px-1 mx-1">
        <div class="w-1 h-1 rounded-full mr-1 bg-red-400"></div>
        <div>No Show Risk</div>
      </div>
      <div class="flex flex-row items-center px-1 mx-1">
        <div class="w-1 h-1 rounded-full mr-1 bg-green-100"></div>
        <div>Expected On Time</div>
      </div>
      <div class="flex flex-row items-center px-1 mx-1">
        <div class="w-1 h-1 rounded-full mr-1 bg-gray-600"></div>
        <div>Excused Absence</div>
      </div>
    </div>-->
  </div>
  <div *ngIf="data$ | async as data" class="p-2 bg-white">
    <lohi-shift-tool-graph [data]="data" (selectedGroup)="setGroup($event)"></lohi-shift-tool-graph>
  </div>
  <div class="p-2 bg-white flex flex-row" *ngIf="group$$ | async as shiftData">
    <ng-container *ngIf="shiftData.DriverGroups.length">
      <div class="flex flex-col mr-2" *ngFor="let group of shiftData.DriverGroups; trackBy: 'name' | trackByKey">
        <div class="font-semibold text-lg">{{ group.Name | titlecase }}</div>
        <div class="text-gray-600 text-sm">{{ group.Description | titlecase }}</div>
        <div class="flex flex-col">
          <div
            *ngFor="let driver of group.Drivers; trackBy: 'Phone' | trackByKey"
            class="flex flex-row items-center p-1"
          >
            <div>{{ driver.Name }} ({{ driver.PhoneNumber | phone }})</div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
